import { render, staticRenderFns } from "./WithIncidentAnswer.vue?vue&type=template&id=72499544&scoped=true"
import script from "./WithIncidentAnswer.ts?vue&type=script&lang=ts&external"
export * from "./WithIncidentAnswer.ts?vue&type=script&lang=ts&external"
import style0 from "./WithIncidentAnswer.scss?vue&type=style&index=0&id=72499544&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72499544",
  null
  
)

export default component.exports